import { render, staticRenderFns } from "./RankingCriteria_new.vue?vue&type=template&id=573f0e62"
import script from "./RankingCriteria_new.vue?vue&type=script&lang=js"
export * from "./RankingCriteria_new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports